export class Material {
  id: number;
  file: string;
  name: string;
  category: string;
  category_name: string;
  start_date: string;
  end_date: string;
  comments: string;
  stores_ids: number[];
  push: boolean;

  constructor() {
    this.file = '';
    this.name = '';
    this.category = '';
    this.start_date = '';
    this.end_date = '';
    this.comments = '';
    this.stores_ids = [];
  }
}



// WEBPACK FOOTER //
// /app/src/app/_models/material.ts